import type { FunctionComponent } from 'react';

import { NickNameSettingsMobileEditConnected } from '../../../settings/nickName/NickNameSettingsMobileEditConnected';
import { NavPage } from '../page/NavPage';

import styles from './NavPageNickNameConnected.module.css';

export const NavPageNickNameConnected: FunctionComponent = () => {
  return (
    <NavPage>
      <div className={styles.navPageNickNameConnected}>
        <NickNameSettingsMobileEditConnected />
      </div>
    </NavPage>
  );
};
